import { resolveMediaUrl } from "@utils/media/mediaUrl";

function normalizeLocalizedForPopup(value) {
  if (!value) return {};
  if (Array.isArray(value)) {
    return value.reduce((acc, item) => {
      if (!item || typeof item !== "object") return acc;
      const entries = Object.entries(item).filter(([key]) => key !== "id");
      if (!entries.length) return acc;
      const [iso, text] = entries[0];
      acc[iso] = { value: String(text || ""), id: String(item?.id || "") };
      return acc;
    }, {});
  }
  if (typeof value === "object") return value;
  return { es: { value: String(value || ""), id: "" } };
}

export function buildRoutePointPopupMeta(point = {}, fallbackPointType = "") {
  const imageItems = Array.isArray(point?.images)
    ? point.images.map((item) => ({
        ...item,
        url: resolveMediaUrl(String(item?.url || "")),
        mediaType: "image",
      }))
    : [];
  const audioItems = Array.isArray(point?.audios)
    ? point.audios.map((item) => ({
        ...item,
        url: resolveMediaUrl(String(item?.url || "")),
        mediaType: "audio",
      }))
    : [];
  return {
    name: normalizeLocalizedForPopup(point?.name),
    description: normalizeLocalizedForPopup(point?.description),
    latitude: point?.latitude ?? "",
    longitude: point?.longitude ?? "",
    radiusMeters: Number(point?.radius_meters ?? 0) || 0,
    turnCase: Number(point?.turn_case ?? 0) || 0,
    pointType: String(point?.pointType || point?.point_type || fallbackPointType || ""),
    multimedia: [...imageItems, ...audioItems],
  };
}

export function buildStartPointPopupMeta(startPoint = {}) {
  const descriptionValue =
    typeof startPoint?.description === "string"
      ? { es: { value: startPoint.description, id: "" } }
      : normalizeLocalizedForPopup(startPoint?.description || {});
  const nameValue =
    typeof startPoint?.name === "string"
      ? { es: { value: startPoint.name, id: "" } }
      : normalizeLocalizedForPopup(
          startPoint?.name || startPoint?.zoneName || startPoint?.placeName || "",
        );
  return {
    name: nameValue,
    description: descriptionValue,
    latitude: startPoint?.latitude ?? startPoint?.lat ?? "",
    longitude: startPoint?.longitude ?? startPoint?.lng ?? "",
    radiusMeters: Number(startPoint?.radius_meters ?? startPoint?.radiusMeters ?? 0) || 0,
    turnCase: Number(startPoint?.turn_case ?? startPoint?.turnCase ?? 0) || 0,
    multimedia: [],
  };
}
